export * from './kontakteCommand.service';
import { KontakteCommandService } from './kontakteCommand.service';
export * from './kontakteQuery.service';
import { KontakteQueryService } from './kontakteQuery.service';
export * from './kontaktverwaltungQuery.service';
import { KontaktverwaltungQueryService } from './kontaktverwaltungQuery.service';
export * from './kontaktverwaltungTemplates.service';
import { KontaktverwaltungTemplatesService } from './kontaktverwaltungTemplates.service';
export const APIS = [KontakteCommandService, KontakteQueryService, KontaktverwaltungQueryService, KontaktverwaltungTemplatesService];
